/* eslint-disable i18next/no-literal-string -- css not user facing */
import { defineSlotRecipe } from '@chakra-ui/react';

import { checkmark } from './checkmark';

export const checkbox = defineSlotRecipe({
  slots: ['root', 'control', 'label'],
  className: 'chakra-checkbox',
  base: {
    label: {
      fontWeight: 'normal',
    },
    control: {
      background: 'gray.25',
      _dark: {
        borderRadius: 'sm',
      },
    },
  },

  variants: {
    size: {
      xs: {
        root: { gap: '1.5' },
        label: { textStyle: 'xs' },
        control: checkmark.variants?.size?.xs,
      },
      sm: {
        root: { gap: '2' },
        label: { textStyle: 'md' },
        control: checkmark.variants?.size?.sm,
      },
      md: {
        root: { gap: '2.5' },
        label: { textStyle: 'sm' },
        control: checkmark.variants?.size?.md,
      },
      lg: {
        root: { gap: '3' },
        label: { textStyle: 'md' },
        control: checkmark.variants?.size?.lg,
      },
    },
    variant: {
      solid: {
        control: checkmark.variants?.variant?.solid,
      },
    },
  },

  defaultVariants: {
    size: 'lg',
  },
});
